/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Draft_Not_FoundInputs */

const en_us2_plan_draft_not_found = /** @type {(inputs: Plan_Draft_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is no draft waiting for approval.`)
};

const pt_br2_plan_draft_not_found = /** @type {(inputs: Plan_Draft_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há rascunho esperando aprovação.`)
};

const pt_pt2_plan_draft_not_found = /** @type {(inputs: Plan_Draft_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há rascunho esperando aprovação.`)
};

/** @type {(inputs: Plan_Draft_Not_FoundInputs) => LocalizedString} */
const es_419_plan_draft_not_found = en_us2_plan_draft_not_found;

/** @type {(inputs: Plan_Draft_Not_FoundInputs) => LocalizedString} */
const fr_fr2_plan_draft_not_found = en_us2_plan_draft_not_found;

/** @type {(inputs: Plan_Draft_Not_FoundInputs) => LocalizedString} */
const de_de2_plan_draft_not_found = en_us2_plan_draft_not_found;

/** @type {(inputs: Plan_Draft_Not_FoundInputs) => LocalizedString} */
const it_it2_plan_draft_not_found = en_us2_plan_draft_not_found;

/**
* | output |
* | --- |
* | "There is no draft waiting for approval." |
*
* @param {Plan_Draft_Not_FoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_draft_not_found = /** @type {((inputs?: Plan_Draft_Not_FoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Draft_Not_FoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_draft_not_found(inputs)
	if (locale === "es-419") return es_419_plan_draft_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_draft_not_found(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_draft_not_found(inputs)
	if (locale === "de-DE") return de_de2_plan_draft_not_found(inputs)
	if (locale === "it-IT") return it_it2_plan_draft_not_found(inputs)
	return en_us2_plan_draft_not_found(inputs)
});
export { plan_draft_not_found as "plan.draft_not_found" }